export const preloadImg = (src: string): Promise<void> =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	new Promise((resolve: (result: Promise<never>) => void, reject: (error?: any) => void) => {
		const img = new Image();
		// @ts-expect-error - TS2322 - Type '(result: Promise<never>) => void' is not assignable to type '(this: GlobalEventHandlers, ev: Event) => any'.
		img.onload = resolve;
		img.onerror = reject;
		img.src = src;
	});
